import {
  GROUP_LISTE_REQUETTE,
  GROUP_LISTE_SUCCES,
  GROUP_LISTE_ECHEC,
  GROUP_CREATION_REQUETTE,
  GROUP_CREATION_SUCCES,
  GROUP_CREATION_ECHEC,
  GROUP_DETAILS_REQUETTE,
  GROUP_DETAILS_SUCCES,
  GROUP_DETAILS_ECHEC,
} from "../constantes/groupcliConstantes";
export const listeGroupReducer = (state = { groupes: [] }, action) => {
  switch (action.type) {
    case GROUP_LISTE_REQUETTE:
      return { loading: true };
    case GROUP_LISTE_SUCCES:
      return { loading: false, groupes: action.payload };
    case GROUP_LISTE_ECHEC:
      return { loading: false, erreur: action.payload };
    default:
      return state;
  }
};
export const creeGroupReducer = (state = { group: {} }, action) => {
  switch (action.type) {
    case GROUP_CREATION_REQUETTE:
      return { loading: true };
    case GROUP_CREATION_SUCCES:
      return { loading: false, group: action.payload };
    case GROUP_CREATION_ECHEC:
      return { loading: false, erreur: action.payload };
    default:
      return state;
  }
};
